import { computed, watch, onMounted, openBlock, createElementBlock, normalizeClass, normalizeStyle, createElementVNode, mergeProps, toDisplayString, createTextVNode, createCommentVNode } from 'vue';
import { createComponent } from './utils/create-component';
import propTypes from './utils/prop-types';
import { CHANGE_EVENT, BLUR_EVENT, FOCUS_EVENT, INPUT_EVENT } from './utils/constants';
import { useInputModel } from './utils/hooks/use-input-model';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var props = {
  height: propTypes.number().def(72),
  modelValue: propTypes.oneOfType([propTypes.string(), propTypes.number()]).def(''),
  placeholder: propTypes.string().def('请输入'),
  maxlength: propTypes.oneOfType([propTypes.string(), propTypes.number()]).def(''),
  disabled: propTypes["boolean"]().def(false),
  autofocus: propTypes["boolean"]().def(false),
  autocomplete: propTypes.string().def(''),
  readonly: propTypes["boolean"]().def(false),
  showWordLimit: propTypes["boolean"]().def(false),
  border: propTypes["boolean"]().def(true)
};
var emits = [CHANGE_EVENT, BLUR_EVENT, FOCUS_EVENT, INPUT_EVENT];

var _createComponent = createComponent('textarea'),
  create = _createComponent.create,
  className = _createComponent.className;
var script = create({
  props: props,
  emits: emits,
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var inputClass = computed(function () {
      var _ref2;
      return ["".concat(className), (_ref2 = {}, _defineProperty(_ref2, "".concat(className, "-disabled"), props.disabled), _defineProperty(_ref2, "".concat(className, "-border"), props.border), _ref2)];
    });
    /**
     * 显示字符统计时，容器高度为textarea高度+字符统计容器高度
     */
    var realHeight = computed(function () {
      return "".concat(props.maxlength ? props.height + 28 : props.height, "px");
    });
    var _useInputModel = useInputModel(props, emit),
      inputValue = _useInputModel.inputValue,
      inputRef = _useInputModel.inputRef,
      inputProps = _useInputModel.inputProps,
      _useInputModel$effect = _useInputModel.effects,
      onFocus = _useInputModel$effect.onFocus,
      onBlur = _useInputModel$effect.onBlur,
      onClick = _useInputModel$effect.onClick,
      onInput = _useInputModel$effect.onInput,
      onCompositionStart = _useInputModel$effect.onCompositionStart,
      onCompositionEnd = _useInputModel$effect.onCompositionEnd,
      setInputValue = _useInputModel$effect.setInputValue;
    watch(inputValue, function () {
      setInputValue();
    });
    onMounted(function () {
      setInputValue();
    });
    return {
      inputRef: inputRef,
      inputValue: inputValue,
      inputProps: inputProps,
      className: className,
      realHeight: realHeight,
      inputClass: inputClass,
      onBlur: onBlur,
      onFocus: onFocus,
      onClick: onClick,
      onInput: onInput,
      onCompositionStart: onCompositionStart,
      onCompositionEnd: onCompositionEnd
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(_ctx.inputClass),
    style: normalizeStyle({
      height: _ctx.realHeight
    })
  }, [createElementVNode("textarea", mergeProps({
    ref: "inputRef",
    "class": "".concat(_ctx.className, "__textarea")
  }, _ctx.inputProps, {
    onBlur: _cache[0] || (_cache[0] = function () {
      return _ctx.onBlur && _ctx.onBlur.apply(_ctx, arguments);
    }),
    onFocus: _cache[1] || (_cache[1] = function () {
      return _ctx.onFocus && _ctx.onFocus.apply(_ctx, arguments);
    }),
    onInput: _cache[2] || (_cache[2] = function () {
      return _ctx.onInput && _ctx.onInput.apply(_ctx, arguments);
    }),
    onCompositionstart: _cache[3] || (_cache[3] = function () {
      return _ctx.onCompositionStart && _ctx.onCompositionStart.apply(_ctx, arguments);
    }),
    onCompositionend: _cache[4] || (_cache[4] = function () {
      return _ctx.onCompositionEnd && _ctx.onCompositionEnd.apply(_ctx, arguments);
    })
  }), "\n        ", 16 /* FULL_PROPS */), _ctx.showWordLimit && _ctx.maxlength ? (openBlock(), createElementBlock("div", {
    key: 0,
    "class": normalizeClass("".concat(_ctx.className, "__word-limit"))
  }, [createElementVNode("span", {
    "class": normalizeClass(_defineProperty({}, "".concat(_ctx.className, "__word-limit-error"), _ctx.inputValue.length >= +_ctx.maxlength))
  }, toDisplayString(_ctx.inputValue.length), 3 /* TEXT, CLASS */), createTextVNode("/" + toDisplayString(_ctx.maxlength), 1 /* TEXT */)], 2 /* CLASS */)) : createCommentVNode("v-if", true)], 6 /* CLASS, STYLE */);
}

script.render = render;
script.__file = "components/src/component/textarea/textarea.vue";

var _Textarea = script;

export { _Textarea as default };
